import { FRONTEND_ENV } from '@src/env'

// Borseria has no external marketing site: WEBFLOW_BASE_URL is the app's own
// origin, so redirecting '/' there would loop back onto itself forever
export const externalUrls = {}

export default function externalRedirect(lang, refUrl) {
  let pathname = window.location.pathname
  if (refUrl) {
    pathname = new URL(refUrl).pathname
  }

  // External redirects are for production only, to have easier access to dev
  // (React will re-route to login page)
  if (!FRONTEND_ENV.isProduction) {
    return null
  }

  const destination = externalUrls[pathname]
  if (!destination || !destination[lang]) {
    return null
  }

  return destination[lang]
}
